const passengers = {
  table: {
    headers: {
      createBtn: 'Crear',
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Telefono',
      baseAddress: 'Dirección de domicilio',
      alternateAddress: 'Dirección alternativa',
      occupationAddress: 'La escuela',
      createdAt: 'Creado en',
      profile: 'Perfil',
    },
  },
};

export default passengers;
